;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:propstrata-app":true});}catch(e){}}();import type { StateStorage } from "zustand/middleware";
import { logger } from "@/lib/services/logger";

const isServer = typeof window === "undefined";

export const createStorage = (type: "local" | "session"): StateStorage => {
	if (isServer) {
		return {
			getItem: () => null,
			removeItem: () => {},
			setItem: () => {},
		};
	}

	const storage =
		type === "local" ? window.localStorage : window.sessionStorage;

	return {
		getItem: (name: string): string | null => {
			try {
				const value = storage.getItem(name);
				if (!value) return null;

				// Parse and validate the stored value
				const parsed = JSON.parse(value);
				if (!parsed.state || !parsed.version) {
					logger.warn(`Invalid storage format for ${name}`, {
						feature: "storage",
					});
					return null;
				}

				return value;
			} catch (error) {
				logger.error(
					`Error reading from ${type}Storage`,
					error instanceof Error ? error : new Error(String(error)),
					{ feature: "storage" },
				);
				return null;
			}
		},
		removeItem: (name: string): void => {
			try {
				storage.removeItem(name);
			} catch (error) {
				logger.error(
					`Error removing from ${type}Storage`,
					error instanceof Error ? error : new Error(String(error)),
					{ feature: "storage" },
				);
			}
		},
		setItem: (name: string, value: string): void => {
			try {
				storage.setItem(name, value);
			} catch (error) {
				logger.error(
					`Error writing to ${type}Storage`,
					error instanceof Error ? error : new Error(String(error)),
					{ feature: "storage" },
				);
			}
		},
	};
};
